<template>
    <section class="text-main-primary bg-white p-6 rounded-lg shadow-element">
        <h4 class="font-bold text-[16px]">Отметить автора материала</h4>
        <p class="text-xs my-2">*Обязательные поля</p>
        <form @submit.prevent="sendRequest">
            <div  class=" space-y-2">
                <!-- ФИО -->
                <section class="flex grid grid-cols-2 gap-x-3">
                    <div class="sm:col-span-1 col-span-2">
                        <JetLabel class="text-xs"
                                  for="first_name"
                                  :value="$t('contact_information.first_name') + '*'" />
                        <JetInput id="first_name"
                                  type="text"
                                  class="mt-1 block w-full shadow-element text-sm"
                                  v-model="form.first_name"
                                  autocomplete="first_name" />
                        <JetInputError :message="form.errors.first_name"
                                       class="mt-2" />
                    </div>
                    <div class="sm:col-span-1 col-span-2">
                        <JetLabel class="text-xs"
                                  for="last_name"
                                  :value="$t('contact_information.last_name') + '*'" />
                        <JetInput id="last_name"
                                  type="text"
                                  class="mt-1 block w-full shadow-element text-sm"
                                  v-model="form.last_name"
                                  autocomplete="last_name" />
                        <JetInputError :message="form.errors.last_name"
                                       class="mt-2" />
                    </div>
                </section>
                <div class="md:w-2/3 w-full">
                    <JetLabel class="text-xs"
                              for="email"
                              :value="$t('profile_information.email') + '*'" />
                    <JetInput id="email"
                              type="email"
                              class="mt-1 block w-full shadow-element text-sm"
                              v-model="form.email"
                              autocomplete="email" />
                    <JetInputError :message="form.errors.email"
                                   class="mt-2" />
                </div>
                <section class="flex grid grid-cols-2 gap-x-3">
                    <div class="sm:col-span-1 col-span-2">
                        <JetLabel class="text-xs"
                                  for="company"
                                  :value="'Компания*'" />
                        <JetInput id="company"
                                  type="text"
                                  class="mt-1 block w-full shadow-element text-sm"
                                  v-model="form.company" />
                        <JetInputError :message="form.errors.company"
                                       class="mt-2" />
                    </div>
                    <div class="sm:col-span-1 col-span-2">
                        <JetLabel class="text-xs"
                                  for="position"
                                  :value="$t('vacancy_request.position') + '*'" />
                        <JetInput id="position"
                                  type="text"
                                  class="mt-1 block w-full shadow-element text-sm"
                                  v-model="form.position" />
                        <JetInputError :message="form.errors.position"
                                       class="mt-2" />
                    </div>
                </section>
				
                <section class="flex items-center cursor-pointer pt-3"
                         @click="form.agree = !form.agree"  >
                    <input class="rounded"
                           type="checkbox"
                           name="form.agree"
                           id="form.agree"
                           v-model="form.agree">
                    <span class="ml-2 text-[12px] md:text-sm">{{$t('vacancy_request.agree')}}</span>
                </section>
			
            </div>
			
            <template class="flex flex-col md:flex-row items-center justify-end py-3 mt-[14px] gap-x-3 text-right">
                <JetActionMessage class="text-left mb-2"
                                  :on="form.recentlySuccessful">
                    {{$t('vacancy_request.request_accepted')}}
                </JetActionMessage>
				
                <ButtonFree :class="[ form.processing ? 'opacity-25':'opacity-100', form.agree ? 'bg-main-accent text-white border-transparent hover:opacity-90 focus:outline-none focus:border-main-accent focus:ring focus:ring-gray-300':'bg-[#D1D9E2] text-white']"
                            :disabled="form.processing ||!form.agree"
                            class="border rounded-[15px] w-full md:w-auto min-h-[38px] items-center justify-center normal-case font-medium">
                    Откликнуться
                </ButtonFree>
            </template>
        </form>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
import ButtonFree from '@/Components/ButtonFree.vue';
import JetFormSection from '@/Components/FormSection.vue';
import JetInput from '@/Components/TextInput.vue';
import JetInputError from '@/Components/InputError.vue';
import JetLabel from '@/Components/InputLabel.vue';
import JetTextarea from '@/Components/textarea.vue';
import JetActionMessage from '@/Components/ActionMessage.vue';
import JetSecondaryButton from '@/Components/SecondaryButton.vue';

export default defineComponent({
    name: 'JoinContentForm',
    components: {
        JetActionMessage,
        ButtonFree,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetTextarea,
    },
    props: ['element'],
    data() {
        return {
            CSS: {
                container: ['max-w-6xl', 'md:px-24', 'sm:px-6', 'px-2'],
                input: ['rounded', 'bg-blue-232', 'outline-none', 'border-0', 'text-blue-21', 'text-sm', 'w-full', 'mx-1', 'my-2'],
            },
            form: this.$inertia.form({
                _method: 'POST',
                first_name: this.$page.props.auth && this.$page.props.auth.contact ? this.$page.props.auth.contact.first_name : null,
                last_name: this.$page.props.auth && this.$page.props.auth.contact ? this.$page.props.auth.contact.last_name : null,
                email: this.$page.props.auth && this.$page.props.auth.user ? this.$page.props.auth.user.email : null,
                company: this.$page.props.auth && this.$page.props.auth.job ? this.$page.props.auth.job.company : null,
                position: this.$page.props.auth && this.$page.props.auth.job ? this.$page.props.auth.job.position : null,
                content_id: this.element.id,
                agree: false,
            }),
        };
    },
    methods: {
        sendRequest() {
            if (this.form.agree) {
                this.form.post(route('join-content'), {
                    errorBag: 'sendRequest',
                    preserveScroll: true,
                    onSuccess: () => {},
                });
            }
        },
    },
});
</script>
